<template>
  <section v-if="showBanners !== false">
    <!-- Pau Gasol Academy Banner -->
    <div class="estimate" v-show="event.is_campus && isBasket">
      <div class="info">
        <p
          class="text"
          v-html="
            $t('campus.banners.paugasolacademy.doc_imagerights') +
            '<br><br>' +
            $t('campus.banners.info_documents', { s: formDocPage }) +
            '<br><br>' +
            $t('campus.banners.paugasolacademy.limit_date')
          "
        ></p>
      </div>
    </div>

    <!-- Nike Camp Banner -->
    <div class="estimate" v-show="event.is_campus && !isBasket">
      <div class="info">
        <p
          class="text"
          v-html="
            banner_docsok_msg ? $t('campus.banners.docs_ok') : $t('campus.banners.nikecamp.doc_imagerights') +
            '<br><br>' +
            $t('campus.banners.info_documents')
            // + '<br><br>' +
            // $t('campus.banners.info_whatsapp', { s: whatsappLink })
          "
        ></p>
      </div>
    </div>

    <!-- MICFootball Banner -->
    <div class="estimate" v-show="event.type_id == 1 && isPlayerPage">
      <div>
        <p class="text" v-html="$t('micfootball.banners.players')"></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeaderBanners',
  props: {
    event: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    showBanners: {
      type: Boolean,
      default: true
    },
    isPlayerPage: {
      type: Boolean,
      default: false
    },
    banner_docsok_msg: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isBasket () {
      return this.event.name ? this.event.name.toLowerCase() === 'pau gasol academy' : false
    },
    formDocPage () {
      return (
        process.env.VUE_APP_APP_URL +
        this.$route.params.event +
        '/campus/participant_campus/' +
        this.user.participant_id +
        '/edit'
      )
    },
    whatsappLink () {
        let person = this.$store.getters["person/getPerson"];
        switch (parseInt(this.event.type_id)) {
            case 4:
                if(person.campus && person.campus[0] && person.campus[0].id == 'NmFXdmtkVzI0bXhUTE1hZy9wV0NoQT09') {
                    return 'https://chat.whatsapp.com/ImeK6ht8Gwk6PTxfY5oZu5';
                } else {
                    return 'https://chat.whatsapp.com/GrRe6AZPqCzEt5Y2Du1E10';
                }
            case 12:
                return 'https://chat.whatsapp.com/ImeK6ht8Gwk6PTxfY5oZu5'
            case 13:
                return 'https://chat.whatsapp.com/CM8NRPF7RQwL21jcg3GnGx'
        }
    }
  }
}
</script>

<style lang="scss" scoped>
.estimate,
.warning {
  @include display-flex();
  @include align-items();
  @include flex-wrap(wrap);
  @include background(
    $color: $warning-color-light,
    $image: img("empty_estimated_warning.svg"),
    $position: left 25px center,
    $size: 40px
  );
  width: 100%;
  height: auto;
  padding: 30px;
  padding-left: 80px;
  margin: 24px auto;
  border-radius: 3px;

  .info {
    width: calc(100% - 300px);
  }

  .text {
    display: inline-block;
    font-size: 14px;
    margin: 0;
    padding: 0;
    color: #111;
    font-family: AvantGarde-Bold;
  }

  .message_error {
    color: #666;
    display: inline-block;
    font-size: 16px;
    margin-top: 5px;
  }

  .actions {
    @include display-flex();
    @include align-items();
    @include flex-wrap(wrap);
    display: inline-block;
    width: 300px;
    height: 100%;
    text-align: right;
  }

  .value {
    margin: 0;
    padding: 7px;
    display: inline-block;
    width: 80px;
    border: 1px solid $warning-color;
    color: $warning-color-text;
    border-radius: 3px;
    font-size: 22px;
    text-align: center;
    background: #fff;
    vertical-align: top;
  }

  .btn {
    display: inline-block;
    width: auto;
    background-color: #fc8926;
    font-family: AvantGarde-Bold;
    color: #fff;
    border-radius: 3px;
    padding: 10px 25px;
    margin-left: 16px;
    border: 1px solid transparent;
    text-transform: none;
    vertical-align: top;
  }

  &.error {
    .value {
      border-color: $alert-color;
      color: $alert-color;
    }
  }

  &.hide {
    display: none;
  }
}

</style>
